import * as ThresholdConstant from "../../middleware/Constants/ThresholdsConstant";
export { getPeriodDate, getPeriodUnit, consolidateThresholds } from "./AnalyticsUtils";

export const hasThresholds = (data) => {
    if (!data || data.length === 0) {
        return false
    }

    return true;
}

export const getFreeThreshold = (group) => {
    let freeThresholdArray = null;
    if (group && group.thresholds) {
        freeThresholdArray = group.thresholds.filter(item => item.type === ThresholdConstant.ThresholdType.Free);
    }
    return freeThresholdArray && freeThresholdArray.length > 0 ? { ...freeThresholdArray[0] } : null;
}

export const getCustomThreshold = (group) => {
    let customThresholdArray = null;
    if (group && group.thresholds) {
        customThresholdArray = group.thresholds.filter(item => item.type === ThresholdConstant.ThresholdType.Custom);
    }
    return customThresholdArray && customThresholdArray.length > 0 ? { ...customThresholdArray[0] } : null;
}

export const isCustomThresholdAvailableOnServer = (groupName, thresholds) => {
    const foundIndex = thresholds.findIndex(item => item.groupName === groupName);
    let customThresholdArray = null;
    if (foundIndex >= 0) {
        customThresholdArray = getCustomThreshold(thresholds[foundIndex]);
    }
    return customThresholdArray !== null;
}

export const getEmptyCustomThreshold = () => {
    return ({
        notification: ThresholdConstant.ThresholdNotification.None,
        threshold: 0,
        type: ThresholdConstant.ThresholdType.Custom
    });
}